import { TUser } from "@/types";
import { createContext } from "react";

export type TAuthContext = {
    user: TUser | null
    logout: () => void
}

export const AuthContext = createContext<TAuthContext | null>(null);